import { useState } from "react";
import { IonLabel, IonTextarea, IonToggle } from "@ionic/react";
import { Asterisk } from "swing-components";

import { translate } from "~utils";

type AdditionalEditProps = {
  hasAdditionalEdits: boolean;
  additionalEditMemo: string;
  setHasAdditionalEdits: (e: boolean) => void;
  setAdditionalEditMemo: (e: string) => void;
};

export const AdditionalEditField: React.FC<AdditionalEditProps> = ({
  hasAdditionalEdits,
  additionalEditMemo,
  setHasAdditionalEdits,
  setAdditionalEditMemo,
}) => {
  const [temporaryMemo, setTemporaryMemo] = useState(additionalEditMemo);
  const onCheckboxChange = (checked: boolean) => {
    setAdditionalEditMemo(checked ? temporaryMemo : "");
    setHasAdditionalEdits(checked);
  };

  const onInputChange = (e: CustomEvent) => {
    setTemporaryMemo(e.detail.value);
    setAdditionalEditMemo(e.detail.value);
  };

  return (
    <div>
      <div className="flex justify-between items-center">
        <IonLabel>
          <span className="font-medium">{translate("EDIT_REQUEST_ADDITIONAL_EDITS_LABEL")}</span>
        </IonLabel>
        <IonToggle
          aria-checked={true}
          aria-label={`${translate("EDIT_REQUEST_ADDITIONAL_EDITS_LABEL")} ${hasAdditionalEdits ? translate("ARIA_LABEL_SELECTED") : translate("ARIA_LABEL_DESELECTED")}`}
          checked={hasAdditionalEdits}
          onIonChange={(e: CustomEvent) => {
            onCheckboxChange(e.detail.checked);
          }}
          slot="end"
          className="ion-no-padding"
        />
      </div>
      {hasAdditionalEdits && (
        <div css={{ paddingTop: 16 }}>
          <p css={{ margin: 0 }}>
            {translate("EDIT_REQUEST_ADDITIONAL_EDITS_HEADER")}
            <Asterisk />
          </p>
          <IonTextarea
            autoGrow
            value={additionalEditMemo}
            onIonInput={onInputChange}
            debounce={100}
            placeholder={translate("EDIT_REQUEST_ADDITIONAL_EDITS_PLACEHOLDER")}
          />
        </div>
      )}
    </div>
  );
};
